export default __webpack_public_path__ + "static/media/img6.01f73f85.jpg";